<template>
    <div class="app-header-component">
        <div class="app-header-component-wrapper" :key="$store.reloadHeaderApp">
            <div class="user-info-container">
                <div class="user-img-container" @click="showChangeUserImgPage()">
                    <img class="edit-icon-img" src="../../assets/icons/edit.png" alt="">
                    <img class="user-img" :src="$store.user.profileImgUrl" alt="" />
                </div>
                <div class="user-full-name-container">
                    <div class="user-full-name-wrapper">
                        <div class="first-name-container">
                            <p>{{ $store.user.firstName }}</p>
                        </div>
                        <div class="last-name-container">
                            <p>{{ $store.user.lastName }}</p>
                        </div>
                    </div>
                </div>
            </div>

            <div class="fit20-logo-container">
                <img src="../../assets/imgs/fit20_logo_footer.png" alt="fit20_logo">
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'AppHeader',
    data() {
        return {
        };
    },
    methods: {
        showChangeUserImgPage: function () {
            this.$store.showChangeUserImgPage = true;
        },
        // checkOnlineImageExist: function(url) {
        //     return new Promise((resolve) => {
        //         const img = new Image();
        //         img.src = url;

        //         if (img.complete) {
        //         resolve(true);
        //         } else {
        //         img.onload = () => {
        //             resolve(true);
        //         };

        //         img.onerror = () => {
        //             resolve(false);
        //         };
        //         }
        //     });
        // },
    },
    async mounted() {
        // const placeholderImg = require('@/assets/imgs/placeholder_user_img.png');

        // if (placeholderImg === this.$store.user.profileImgUrl) {
        //     // Check if the the profile image of the user exists on the server
        //     console.log("Check profile image");
        //     const url = `https://storage.googleapis.com/fit20_client_app/imgs/clients_profile_photos/${this.$store.user.zohoId}.png`;
        //     console.log(url);
        //     const profileImgExist = await this.$store.checkOnlineImageExist(url);
        //     console.log("profileImgExist: " + profileImgExist);
        //     if (profileImgExist) {
        //       this.$store.user.profileImgUrl = url;
        //     }
        // }
        // console.log("this.$store.user.profileImgUrl 1: " + this.$store.user.profileImgUrl);
        // console.log("this.$store.user.zohoId: " + this.$store.user.zohoId);
        // if (this.$store.user.zohoId) {
        //     console.log("getting user profile img");
        //     try {
        //         const url = `https://storage.googleapis.com/fit20_client_app/imgs/clients_profile_photos/${this.$store.user.zohoId}.png`;
        //         const profileImgExist = await this.$store.checkOnlineImageExist(url);
        //         if (profileImgExist) {
        //             this.$store.user.profileImgUrl = url;
        //             this.$store.setCookie('user', JSON.stringify(this.$store.user), 30);
        //         }
        //         else {
        //             this.$store.user.profileImgUrl = require('@/assets/imgs/placeholder_user_img.png');
        //             this.$store.setCookie('user', JSON.stringify(this.$store.user), 30);
        //         }
        //     }
        //     catch(err) {
        //         console.log(err);
        //         this.$store.user.profileImgUrl = require('@/assets/imgs/placeholder_user_img.png');
        //         this.$store.setCookie('user', JSON.stringify(this.$store.user), 30);
        //     }
        // }
        // this.profileImgUrl = this.$store.user.profileImgUrl;
        // console.log(this.profileImgUrl);
        // console.log("this.$store.user.profileImgUrl 2: " + this.$store.user.profileImgUrl);
        // try {
        //     const url = `https://storage.googleapis.com/fit20_client_app/imgs/clients_profile_photos/${this.$store.user.zohoId}.png`;
        //     const imgExists = await this.checkOnlineImageExist(url);
        //     if (imgExists) {
        //         this.profileImgUrl = url;
        //         this.profileImgExist = true;
        //     }
        // }
        // catch(err) {
        //     console.log('Error while getting user profile image...');
        //     console.log(err);
        // }
    },
    // computed: {
    //     userProfileImgUrl() {
    //         return this.$store.user.profileImgUrl;
    //     }
    // },
}
</script>

<style>
.app-header-component {
    /* height: 80px; */
    /* height: 17vw; */
    /* min-height: 90px; */
    height: 75px;
    /* height: 100px; */
    border-bottom: 2px solid #E6E6E6;
    background-image: url('../../assets/imgs/fit20_dna_header.png');
    background-size: contain;
    background-position: 30px 0;
    /* background-position: 20px; */
    /* background-repeat: no-repeat; */
    box-shadow: 0 0 5px 0 #E6E6E6;
    /* border: 1px solid; */
    overflow: hidden;
}

[dir="rtl"] .app-header-component {
    direction: ltr;
}

.app-header-component .app-header-component-wrapper {
    width: 100%;
    height: 100%;
    display: flex;
    justify-content: space-between;
}

.app-header-component .user-info-container {
    flex: 1;
    /* width: calc(100% - 225px); */
    min-width: calc(100% - 225px);
    max-width: 100%;
    display: flex;
    align-items: center;
    padding: 0 10px;
    /* border: 1px solid red; */
}

.app-header-component .user-img-container {
    position: relative;
    /* height: 80%; */
    /* width: calc(20vw * 0.8); */
    width: 60px;
    height: 60px;
    border-radius: 50%;
    cursor: pointer;
    display: flex;
    justify-content: center;
    align-items: center;
    /* padding: 10px 0; */
    /* border: 1px solid #009df4; */
    /* border: 1px solid; */
}

.app-header-component .user-img-container:hover {
    box-shadow: 0 0 10px rgba(0, 0, 0, 0.3);
}

.app-header-component .user-info-container .edit-icon-img {
    position: absolute;
    top: 0;
    right: 0;
    z-index: 1;
    width: 16px;
    height: 16px;
    display: none;
}

.app-header-component .user-img-container:hover .edit-icon-img {
    display: block;
}

.app-header-component .user-info-container .user-img {
    width: 90%;
    /* height: 100%; */
    border-radius: 50%;
    display: flex;
    /* font-size: 10px; */
    /* border: 1px solid; */
}

.app-header-component .user-full-name-container {
    flex: 1;
    height: 100%;
    padding-left: 10px;
    overflow: hidden;
    /* border: 1px solid rgb(60, 255, 0); */
}

/* [dir="rtl"] .user-full-name-container {
    padding-right: 10px;
} */

.app-header-component .user-full-name-wrapper {
    width: 100%;
    /* width: 100%; */
    height: 100%;
    /* max-width: 100%; */
    /* overflow: hidden; */
    display: flex;
    flex-direction: column;
    justify-content: end;
    align-items: center;
    padding-bottom: 5px;
    /* border: 1px solid blue; */
}

.app-header-component .first-name-container,
.app-header-component .last-name-container {
    width: 100%;
    /* border: 1px solid; */
}

.app-header-component .first-name-container p,
.app-header-component .last-name-container p {
    font-family: 'VAG Rounded Std', sans-serif;
    font-weight: 400;
    font-size: 25px;
    /* font-size: 1.55rem; */
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    letter-spacing: -1px;
    padding-left: 2px;
    /* border: 1px solid black; */
}

.app-header-component .first-name-container p {
    color: #92d400;
}

.app-header-component .last-name-container p {
    color: #616365;
}

.app-header-component .fit20-logo-container {
    height: 100%;
    /* min-width: 150px; */
    max-width: 225px;
    /* border: 1px solid; */
}

.app-header-component .fit20-logo-container img {
    height: 100%;
    /* width: 100%; */
}

@media (max-width: 375px) {

    .app-header-component .first-name-container p,
    .app-header-component .last-name-container p {
        font-size: calc(16px + 2vw);
    }
}

@media (max-width: 320px) {

    .app-header-component .first-name-container p,
    .app-header-component .last-name-container p {
        font-size: calc(16px + 1vw);
    }
}
</style>